/*
 * @author:
 * @Date: 2021-10-22 15:20:00
 * @LastEditTime: 2023-01-03 11:07:12
 * @FilePath: \场外----客户\src\permission.js
 */
import router from './router'
import store from './store'
import commonUtils from './utils/commonUtils.js'
import { getCookie } from './utils/auth.js'

// 1. 白名单不做校验直接访问
// 2. 登陆页面，检查key和cookie，有则跳转主页，没有则维持原路径
// 3. 非登陆页面，检查key和cookie，有则直接访问，没有则跳转登陆页面

router.beforeEach(async (to, from, next) => {
  // 当store中没有key
  const noSessionInMemory = commonUtils.isNull(store.getters.sessionKey)
  // 当store中没有managerKey
  const noManagerSessionInMemory = commonUtils.isNull(
    store.getters.managerSessionKey
  )
  // 白名单路由
  const whiteRouter = ['/stockConfirmSubmit', '/stockConfirmInput', '/changePassword']

  if (
    to.path === '/tradeCustLogin' ||
    to.path === '/LoginEntry' ||
    to.path === '/login'
  ) {
    if (noSessionInMemory) {
      next()
    } else if (getCookie('isFirstLogin')) {
      next()
    } else {
      next('/')
    }
  } else if (to.path === '/ManagerLogin') {
    if (noManagerSessionInMemory) {
      next()
    } else {
      next('/')
    }
  } else if (whiteRouter.includes(to.path)) {
    next()
  } else {
    if (noSessionInMemory && noManagerSessionInMemory) {
      // 如果内存和cookie中均无session，跳转到登录
      if (
        commonUtils.isNull(getCookie('sessionKey')) &&
        commonUtils.isNull(getCookie('managerSessionKey'))
      ) {
        next('/login')
      } else {
        store.commit('cust/SET_SESSION_KEY', getCookie('sessionKey'))
        store.commit('manager/SET_SESSION_KEY', getCookie('managerSessionKey'))
        next()
      }
    } else {
      next()
    }
  }
})
